import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineButton, PrimaryButton } from "../../../../Constant";
import { OUTLINE_BUTTONS, OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const OutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineButton} span={OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary" id="Tooltip-40">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-40" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-outline-primary</ToolTip>
          {OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonButton key={index} item={data} outline={true}/>
          ))}
        </CardBody>
      </Card>
    );
};

export default OutlineButtons;
